<template>
  <div class="advantages">
     <div class="wrap advantages-box">
        <h3>为什么选择云洋科技？</h3>
        <div class="item-list">
          <div class="item">
            <h1>20<span>年</span></h1>
            <p>互联网行业经验</p>
          </div>
          <div class="item">
            <h1>3000<span>+</span></h1>
            <p>成功案例数</p>
          </div>
          <div class="item">
            <h1>6000<span>+</span></h1>
            <p>服务客户数</p>
          </div>
          <div class="item">
            <h1>26.6<span>倍</span></h1>
            <p>自成立盈利增长</p>
          </div>
        </div>
     </div>
  </div>
</template>
  
  <script>
  export default {
    data() {
      return {};
    },
  };
  </script>
  
  <style scoped>
  .advantages{
    width: 100%;
    position: relative;
    /* height: 480px; */
    background-image: url(../assets//images/advantages.jpg);
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;
    padding: 80px 0;
  }
  .advantages img{
    display: block;
    width: 100%;
  }
  .advantages .advantages-box{
    
  }
  .advantages .advantages-box h3{
    text-align: center;
    margin-bottom: 50px;
  }
  .advantages .advantages-box .item{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 30px 0;
  }
  .advantages .advantages-box .item-list{
    display: flex;
    justify-content: space-around;
  }
  .advantages .advantages-box .item h1{
    display: flex;
    font-size: 38px;
   
  }
  .advantages .advantages-box .item h1 span{
    font-size: 18px;
    font-weight: normal;
  }
  .advantages .advantages-box .item p{
    font-size: 18px;
  }

 
  </style>
  